import { FEATURE_FLAG } from "@appsmith/entities/FeatureFlag";

export const FEATURE_WALKTHROUGH_KEYS = {
  [FEATURE_FLAG.ab_ds_binding_enabled]: FEATURE_FLAG.ab_ds_binding_enabled,
  [FEATURE_FLAG.ab_ds_schema_enabled]: FEATURE_FLAG.ab_ds_schema_enabled,
  binding_widget: "binding_widget",
};
